import type * as React from "react";
import { Suspense } from "react";
import { BookingStepTwo } from "@/components/booking";
import { BookingStepOneSkeleton } from "@/components/booking/BookingStepOneSkeleton";

const BookingStepTwoPage: React.FC = () => {
  return (
    <Suspense fallback={<BookingStepOneSkeleton />}>
      <BookingStepTwo />
    </Suspense>
  );
};

export default BookingStepTwoPage;
